export const productNavGroups = [
  {
    id: "reports",
    label: "Business & Trade Intelligence",
    items: [
      {
        id: "business-information-reports",
        title: "Business Information Reports",
        description:
          "Assess customers, suppliers and counterparties through instant database or freshly researched reports.",
        to: "/business-information-report",
        icon: "reports",
      },
      {
        id: "trade-intelligence",
        title: "Trade Risk Intelligence",
        description:
          "Explore shipment activity, products, markets and international trading relationships.",
        to: "/trade-intelligence",
        icon: "trade",
      },
      {
        id: "trade-price-review",
        title: "Trade Price Review",
        description:
          "Benchmark declared transaction prices against recorded trade statistics before opening an LC.",
        to: "/trade-price-review",
        icon: "price",
      },
      // {
      //   id: "self-assessment",
      //   title: "Business Self-Assessment",
      //   description:
      //     "Turn your company information into an independent, decision-ready assessment.",
      //   to: "/self-assessment",
      //   icon: "assessment",
      // },
    ],
  },
  {
    id: "intelligence",
    label: "Data Access & Analysis",
    items: [
      {
        id: "global-company-search",
        title: "Global Company Search",
        description:
          "Find and verify companies across developed and emerging international markets.",
        to: "/global-company-search",
        icon: "search",
      },
      {
        id: "insight-lens",
        title: "Insight Lens®",
        description:
          "Ask questions and extract decision-relevant findings directly from Credence reports.",
        to: "/insight-lens",
        icon: "ai",
      },
      {
        id: "api-services",
        title: "API Services",
        description:
          "Embed company, risk and trade intelligence within existing platforms and workflows.",
        to: "/api-services",
        icon: "api",
      },
    ],
  },
];

export const productNavPaths = [
  "/product",
  "/business-information-report",
  "/global-company-search",
  "/trade-intelligence",
  "/trade-price-review",
  "/api-services",
  "/insight-lens",
  // "/self-assessment",
];
